import type { Region } from "@sg-protect/runtime-config";
import type { ProtectRegion } from "./api/types.ts";

const REGION_TO_PROTECT_REGION: Record<Region, ProtectRegion> = {
    na: "northAmerica",
    eu: "europe"
};

const PROTECT_REGION_TO_REGION: Record<ProtectRegion, Region> = {
    northAmerica: "na",
    europe: "eu"
};

export function toProtectRegion(region: Region): ProtectRegion {
    return REGION_TO_PROTECT_REGION[region];
}

export function fromProtectRegion(region: ProtectRegion): Region {
    return PROTECT_REGION_TO_REGION[region];
}
